import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "Project__documents" }
const _hoisted_2 = { class: "Project__notes" }

import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useProjectStore } from "@/stores/projects";
import { Project } from "@/types";
import NavigateBack from "@/components/ds/navigate-back/NavigateBack.vue";
import { useDebounceFn } from "@vueuse/core";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import { projectToSlug } from "@/tools/projects";
import ProjectDelete from "@/components/pages/project/ProjectDelete.vue";
import ProjectDetails from "@/components/pages/project/ProjectDetails.vue";
import Panel from "@/components/general/Panel.vue";
import ProjectDocuments from "@/components/pages/project/ProjectDocuments.vue";
import ProjectComments from "@/components/pages/project/comments/ProjectComments.vue";
import InnSection from "@/components/general/Section.vue";
import ItemPage from "@/components/general/ItemPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const projectsStore = useProjectStore();
const uiStore = useUiStore();

const project = ref<Project | null>(null);
const watchActive = ref(false);

const atBack = () => {
    router.push({ name: "Projects" });
};

const debouncedFn = useDebounceFn(() => {
    if (project.value) {
        api.update(project.value, "projects").then(() => {
            uiStore.message("Wijzigingen opgeslagen...");
        });
    }
}, 1000);

watch(
    () => project.value,
    () => {
        if (watchActive.value) {
            debouncedFn();
        }
    },
    { deep: true }
);

onMounted(() => {
    const slug = route.params.slug;
    const p = projectsStore.list.find((project: Project) => {
        const projectSlug = projectToSlug(project, -1);
        return projectSlug === slug;
    });
    if (p) {
        project.value = p;
        setTimeout(() => {
            watchActive.value = true;
        });
    } else {
        router.push({ name: "Projects" });
    }
});

return (_ctx: any,_cache: any) => {
  return (project.value)
    ? (_openBlock(), _createBlock(ItemPage, { key: 0 }, {
        header: _withCtx(() => [
          _createVNode(NavigateBack, { onClick: atBack }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Terug naar projecten ")
            ])),
            _: 1
          })
        ]),
        cols: _withCtx(() => [
          _createVNode(Panel, { title: "Details" }, {
            default: _withCtx(() => [
              _createVNode(ProjectDetails, { project: project.value }, null, 8, ["project"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Panel, { title: "Facturen" }, {
              default: _withCtx(() => [
                _createVNode(ProjectDocuments, {
                  doctype: "invoice",
                  project: project.value
                }, null, 8, ["project"])
              ]),
              _: 1
            }),
            _createVNode(Panel, { title: "Offertes" }, {
              default: _withCtx(() => [
                _createVNode(ProjectDocuments, {
                  doctype: "quotation",
                  project: project.value
                }, null, 8, ["project"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Panel, { title: "Notities" }, {
              default: _withCtx(() => [
                _createVNode(ProjectComments, { project: project.value }, null, 8, ["project"])
              ]),
              _: 1
            }),
            _createVNode(Panel, { title: "Tools" }, {
              default: _withCtx(() => [
                _createVNode(InnSection, null, {
                  default: _withCtx(() => [
                    _createVNode(ProjectDelete, { project: project.value }, null, 8, ["project"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})